import React from 'react';
import BeatLoader from 'react-spinners/BeatLoader';

export enum CustomSpinnerColor {
  White = 'white',
  PrimaryMagenta = 'primaryMagenta',
}

interface CustomSpinnerProps {
  color: CustomSpinnerColor;
  size?: number;
  style?: React.CSSProperties;
}

const COLOR_MAPPER = {
  white: '#fff',
  primaryMagenta: '#f32a52',
};

const CustomSpinner = ({ color, size = 10, style }: CustomSpinnerProps) => {
  return <BeatLoader color={COLOR_MAPPER[color]} size={size} style={style} />;
};

export default CustomSpinner;
